export const wordIntoLetters = (word: string): string[] => {
  return word.toLowerCase().split("");
}